






import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product } from '@/api';
import BillingSetupForm from './billing-setup-form.vue';

@Component({
	components: {
		BillingSetupForm,
	},
})
export default class BillingSetupModal extends Vue {
	@Prop({ required: true, type: Object })
	public product!: Product;
}
